import { render } from "./ShopOrders.vue?vue&type=template&id=1ba1c053&scoped=true"
import script from "./ShopOrders.vue?vue&type=script&lang=js"
export * from "./ShopOrders.vue?vue&type=script&lang=js"

import "./ShopOrders.vue?vue&type=style&index=0&id=1ba1c053&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba1c053"]])

export default __exports__